<template>
  <section id="app" class="app loading">
    <div class="tib-loader">
        <div class="tlp1">
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
        <div class="tlp2">
          <svg class="tibapp-shape" width="100%" height="100vh" preserveAspectRatio="none" viewBox="0 0 1440 800"><path d="M -44,-50 C -52.71,28.52 15.86,8.186 184,14.69 383.3,22.39 462.5,12.58 638,14 835.5,15.6 987,6.4 1194,13.86 1661,30.68 1652,-36.74 1582,-140.1 1512,-243.5 15.88,-589.5 -44,-50 Z" pathdata:id="M -44,-50 C -137.1,117.4 67.86,445.5 236,452 435.3,459.7 500.5,242.6 676,244 873.5,245.6 957,522.4 1154,594 1593,753.7 1793,226.3 1582,-126 1371,-478.3 219.8,-524.2 -44,-50 Z"></path>
          </svg>
        </div>
    </div>
    <div class="tib-app">
      <Header />
      <Nav />
      <transition name="fade" mode="out-in">
        <template>
          <router-view />
        </template>
      </transition>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import { TweenMax, Power1, Linear } from 'gsap'
import * as ScrollToPlugin from 'gsap/ScrollToPlugin'
import $ from 'jquery'

export default {
  name: 'App',
  components: {
    Header,
    Nav
  },
  methods: {
    hideLoader () {
      setTimeout(function () {
        var t = document.querySelector('html')
        t.classList.add('endLoading')
        t.classList.remove('inLoading')
        t.classList.remove('endLoading')
        TweenMax.to('.tib-loader', 2, { css: { 'transform': 'translateY(-200vh)' }, ease: Linear.easeInOutSine })
        var $dataAttr = document.querySelector('.tibapp-shape path').getAttribute('pathdata:id')
        TweenMax.to('.tibapp-shape path', 0.5, { attr: { d: $dataAttr }, ease: Linear.easeInOutSine })
      }, 20)
    },
    handleScroll (event) {
      var $window = $(window)
      var $body = $('body')
      var $panel = $('.panel')
      var scroll = $window.scrollTop()
      $panel.each(function () {
        var $this = $(this)
        var $halfWindow = $window.height() - 100
        if ($('.panel').hasClass('contact')) {
          $halfWindow = $window.height() / 2
        }
        if ($('.panel').hasClass('footer')) {
          $halfWindow = $window.height() / 2
        }
        if (($this.position().top - $halfWindow) <= scroll && ($this.position().top - $halfWindow) + $this.height() > scroll) {
          $body.removeAttr('class')
          $body.addClass('color-' + $(this).data('color'))
        }
      })
    }
  },
  created () {
    this.hideLoader()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    var $window = $(window)
    var $body = $('body')
    var $panel = $('.panel')
    var scroll = $window.scrollTop()
    $panel.each(function () {
      var $this = $(this)
      var $halfWindow = $window.height() - 100
      if ($('.panel').hasClass('contact')) {
        $halfWindow = $window.height() / 2
      }
      if ($('.panel').hasClass('footer')) {
        $halfWindow = $window.height() / 2
      }
      if (($this.position().top - $halfWindow) <= scroll && ($this.position().top - $halfWindow) + $this.height() > scroll) {
        $body.removeAttr('class')
        $body.addClass('color-' + $(this).data('color'))
      }
    })
  }
}
</script>

<style lang='scss'>
/* css loading icon */
.lds-ring {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top:50%;
  left:50%;
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* css loading icon */
html.loading{
  overflow:hidden;
}
.tibapp-shape{
  fill:#d95b4e;
}
.tib-loader{
  z-index: 999999;
  height: 100%;
  width: 100%;
  // display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background-color: #d95b4e;
}
.tlp1{
  font-size: 100px;
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
}
.tlp1, .tlp2{
  height:100vh;
  width: 100%;
  display: block;
  position: relative;
}
.tib-app{
   opacity:0;
   animation: going 4s;
}
html.lc .tib-app{
   opacity:1;
   animation: coming 0.8s;
}
.fade-enter-active, .fade-leave-active {
  animation: coming 10s;
  opacity: 0.5;
}

.fade-enter, .fade-to{
opacity:0;
}

@keyframes going {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@font-face {
  font-family: 'Origin_Gordita';
  src: url('../src/assets/fonts/Origin_Gordita-Regular.eot');
  src: url('../src/assets/fonts/Origin_Gordita-Regular.eot?#iefix') format("embedded-opentype"), url('../src/assets/fonts/Origin_Gordita-Regular.woff2') format("woff2"), url('../src/assets/fonts/Origin_Gordita-Regular.woff') format("woff"), url('../src/assets/fonts/Origin_Gordita-Regular.ttf') format("truetype"), url('../src/assets/fonts/Origin_Gordita-Regular.svg#Origin_Gordita-Regular') format("svg");
  font-weight: normal;
  font-style: normal;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'Origin_Gordita';
  src: url('../src/assets/fonts/Origin_Gordita-Medium.eot');
  src: url('../src/assets/fonts/Origin_Gordita-Medium.eot?#iefix') format("embedded-opentype"), url('../src/assets/fonts/Origin_Gordita-Medium.woff2') format("woff2"), url('../src/assets/fonts/Origin_Gordita-Medium.woff') format("woff"), url('../src/assets/fonts/Origin_Gordita-Medium.ttf') format("truetype"), url('../src/assets/fonts/Origin_Gordita-Medium.svg#Origin_Gordita-Medium') format("svg");
  font-weight: 500;
  font-style: normal;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'Portico-Regular';
  src: url('../src/assets/fonts/Portico-Regular.eot?#iefix') format("embedded-opentype"), url('../src/assets/fonts/Portico-Regular.woff') format("woff"), url('../src/assets/fonts/Portico-Regular.ttf') format("truetype"), url('../src/assets/fonts/Portico-Regular.svg#Portico-Regular') format("svg");
  font-weight: normal;
  font-style: normal;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'Portico-Vintage';
  src: url('../src/assets/fonts/Portico-Vintage.eot?#iefix') format("embedded-opentype"), url('../src/assets/fonts/Portico-Vintage.woff') format("woff"), url('../src/assets/fonts/Portico-Vintage.ttf') format("truetype"), url('../src/assets/fonts/Portico-Vintage.svg#Portico-Vintage') format("svg");
  font-weight: normal;
  font-style: normal;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'DeValencia-Regular';
  src: url('../src/assets/fonts/DeValencia-Regular.eot?#iefix') format("embedded-opentype"), url('../src/assets/fonts/DeValencia-Regular.otf') format("opentype"), url('../src/assets/fonts/DeValencia-Regular.woff') format("woff"), url('../src/assets/fonts/DeValencia-Regular.ttf') format("truetype"), url('../src/assets/fonts/DeValencia-Regular.svg#DeValencia-Regular') format("svg");
  font-weight: normal;
  font-style: normal;
  unicode-range: U+000-5FF;
}
@import "../node_modules/vue2-animate/src/sass/vue2-animate.scss";

h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, var, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video, ul, li {
  margin:0;
  padding:0;
  border:0;
  outline:0;
  font-size:100%;
  font-weight:normal;
  vertical-align:baseline;
  background:transparent;
  list-style:none;
}
article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
  display:block;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  position: relative;
  &:before, &:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: none;
    position: relative;
  }
}
.clearfix {
  display: block;
  &:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
}
html {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Origin_Gordita';
  font-size: 18px;
  font-weight: normal;
  color: #56320e;
  padding: 0;
  margin: 0;
  background: #70c0a3;
  text-size-adjust: none;
  position:relative;
  /* cursor: none; */
  overflow-x:hidden;
  &:after{
    content:"";
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    transition: all .8s ease;
    z-index: -1;
    opacity: 0;
  }
  &.color-green {
    &::after{
      background: #70c0a3;
      opacity: 1;
    }
  }
  &.color-red {
    &::after{
      background:#d95b4e;
      opacity: 1;
    }
  }
  &.color-gray {
    &::after{
      background:#425454;
      opacity: 1;
    }
  }
}
img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
a {
  font-family: 'Origin_Gordita';
  font-weight: 500;
  color: #f4eeb4;
  text-decoration: none;
  transition: all .5s ease;
  position: relative;
  cursor: pointer; 
  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    right: 0;
    width: 100%;
    height: 2px;
    background: #f4eeb4;
    transition: all .5s ease;
  }
  &:hover {
    color: #f4eeb4;
    &:after {
      width: 0;
    }
  }
}
button{
  cursor:pointer;
}
* {
  box-sizing: border-box;
}
h2 {
  display: inline-block;
  font-family: 'Portico-Vintage';
  font-size: 150px;
  color: #f4eeb4;
}
.h2-tagline {
  display: inline-block;
  font-family: 'DeValencia-Regular';
  font-size: 150px;
  position: relative;
  color: #f4eeb4;
  padding: 10px 20px 10px 20px;
  letter-spacing: -48px;
  transform: skew(0deg, -25deg) translate(0, -96%);
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 100%;
    background: rgba(234, 80, 70, 0.9);
    z-index: -1;
    animation-duration: .5s;
    animation-fill-mode: both;
    animation-delay: 1s;
    animation-name: BgDraw;
  }
}
@keyframes BgDraw {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
h3 {
  display: inline-block;
  font-family: 'Portico-Vintage';
  font-size: 100px;
  color: #f4eeb4;
}
.h3-tagline {
  display: inline-block;
  font-family: 'DeValencia-Regular';
  font-size: 100px;
  position: relative;
  color: #f4eeb4;
  padding: 0 35px 0 0;
  letter-spacing: -35px;
  transform: skew(0deg, -25deg) translate(0, -96%);
}
h4 {
  font-family: 'Origin_Gordita';
  font-size: 52px;
  font-weight: 500;
}
h5 {
  font-family: 'Origin_Gordita';
  font-size: 40px;
  font-weight: 500;
}
h6 {
  font-family: 'Origin_Gordita';
  font-size: 24px;
  font-weight: 500;
}
p {
  font-family: 'Origin_Gordita';
  font-size: 18px;
}
.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}
.app,
.smooth-scrollbar,
.scroll-content{
  width: 100%;
  height: 100%;
}
.page-title{
  float:left;
  width:100%;
  padding: 200px 0;
  .container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-left{
    .h3-tagline{
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-name: fadeInUpSkew2 !important;
      text-align: left;
      height:180px;
      span{
        display: inline-block;
        width:0px;
        overflow: hidden;
        text-align: left;
        white-space: nowrap;
      }
      &.v-wow-visible{
        span{
          animation-duration: .5s;
          animation-fill-mode: both;
          animation-delay: 0s;
          animation-name: titleLetterTyping;
          text-align: left;
        }
      }
    }
  }
  &-right{
    display: inline-block;
    width: 55%;
    text-align: left;
    h4{
      a{
        display:inline-block;
      }
    }
  }
  @keyframes fadeInUpSkew2 {
    0% {
      opacity: 0;
      transform: translateY(20px) skew(0deg, -25deg) translate(-20px, 20%);
    }
    100% {
      opacity: 1;
      transform: translateY(0) skew(0deg, -25deg) translate(-20px, 20%);
    }
  }
  @keyframes titleLetterTyping{
    0% {
      width:0px;
    }
    10% {
      width:10%;
    }
    20% {
      width:20%;
    }
    30% {
      width:30%;
    }
    40% {
      width:40%;
    }
    50% {
      width:50%;
    }
    60% {
      width:60%;
    }
    70% {
      width:60%;
    }
    70% {
      width:70%;
    }
    80% {
      width:80%;
    }
    90% {
      width:90%;
    }
    100% {
      width:calc(100% + 35px);
    }
  }
}
body.color-red{
  .page-title{
    &-left{
      span{
        color:#ffebae;
      }
    }
    &-right{
      h4{
        color:#fffbed;
      }
    }
  }
}
.tanim{
  transition:transform ease .5s;
  will-change:transform;
}
.lightSpeedIn {
  animation-name:lightSpeedIn;
  perspective: 400px;
  animation-duration: 1.5s;
  animation-delay: 0s;
  opacity:0;
  animation-fill-mode: forwards;
}
@-webkit-keyframes lightSpeedIn {
  0% {
    opacity:1;
    transform:translate3d(0,50%,0) skewY(-7deg);
  }
  100% {
    opacity:1;
    transform:translate3d(0,0,0) skewY(0deg);
  }
}
@keyframes lightSpeedIn {
  0% {
    opacity:1;
    transform:translate3d(0,50%,0) skewY(-7deg);
  }
  100% {
    opacity:1;
    transform:translate3d(0,0,0) skewY(0deg);
  }
}
.cursor-fx{
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
}
@media screen and (max-width: 1280px) {
  .container {
    max-width: 100%;
    padding:0 50px;
  }
}
@media screen and (max-width: 1080px) {
  h2 {
    font-size: 130px;
  }
  .h2-tagline {
    font-size: 130px;
    letter-spacing: -42px;
  }
  .page-title{
    padding:150px 0 0;
    .container{
      align-items: flex-start;
    }
    &-left{
      .h3-tagline{
        margin:-15px 0 50px 5px;
        height:120px;
      }
    }
    &-right{
      width:70%;
    }
  }
}
@media screen and (max-width: 1024px) {
  /* body {
    cursor:auto;
  }
  .cursor {
    display:none;
  } */
}
@media screen and (max-width: 980px) {
  h4 {
    font-size: 40px;
    line-height: inherit;
  }
  h5 {
    font-size: 34px;
  }
}
@media screen and (max-width: 767px) {
  h2 {
    font-size: 90px;
  }
  .h2-tagline {
    font-size: 90px;
    letter-spacing: -30px;
  }
  .container {
    padding:0 30px;
  }
  .page-title{
    padding:100px 0 0;
    .container{
      flex-wrap: wrap;
    }
    &-left{
      margin:0 0 30px 5px;
      .h3-tagline{
        margin:-15px 0 30px 0;
        height:80px;
      }
    }
    &-right{
      width:100%;
    }
  }
}
@media screen and (max-width: 568px) {
  h3 {
    font-size:80px;
  }
  h4 {
    font-size:33px;
  }
  h5 {
    font-size: 26px;
  }
}
@media screen and (max-width: 436px) {
  h2 {
    font-size: 80px;
  }
  .h2-tagline {
    font-size: 80px;
    letter-spacing: -25px;
    padding: 10px 20px 10px 12px;
  }
  h3 {
    font-size:70px;
  }
  .h3-tagline {
    font-size:70px;
    letter-spacing:-24px;
  }
  h4{
    font-size:30px;
  }
}
</style>
